import Vimeo from '@vimeo/player'

export const initVideos = () => {
  const tag = document.createElement('script')
  tag.src = '//www.youtube.com/player_api'
  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

  window.onYouTubeIframeAPIReady = () => {
    const mediaVideos = Array.from(
      document.querySelectorAll('.media-section__video'),
    )

    mediaVideos.forEach((video) => {
      const iframe = video.querySelector('iframe')

      if (iframe) {
        const videoId = iframe.getAttribute('id')

        if (iframe.getAttribute('src').includes('youtube')) {
          iframe.src = `${iframe.getAttribute('src')}&rel=0&modestbranding=1`

          new YT.Player(videoId, {
            events: {
              onReady: (event) => {
                const cover = video.querySelector('.media-section__cover')
                if(cover){
                  cover.addEventListener('click', () => {
                    cover.classList.add('hide')
                    event.target.playVideo()
                  })
                }
              },
            },
          })
        } else if (iframe.getAttribute('src').includes('vimeo')) {
          const vimeoVideo = new Vimeo(videoId)

          const cover = video.querySelector('.media-section__cover')
          cover.addEventListener('click', () => {
            cover.classList.add('hide')
            vimeoVideo.play()
          })
        }
      }
    })
  }

  const comparisons = Array.from(document.querySelectorAll('.comparison-card'))
  comparisons.forEach((card) => {
    const video = card.querySelector('video')
    const pause = card.querySelector('.pause')
    const play = card.querySelector('.play')

    pause.addEventListener('click', () => {
      pause.classList.remove('show')
      play.classList.add('show')
      video.pause()
    })

    play.addEventListener('click', () => {
      pause.classList.add('show')
      play.classList.remove('show')
      video.play()
    })
  })
}
